import type { StringKey } from '@ipfabric/utils';
import type { FormikProps } from 'formik';
import type { JSX } from 'react';
import type { NestedFormikName } from 'utils/formik/nestedFormikName';

interface Props<TFormikValues> {
  className?: string;
  disabled?: boolean;
  formik: FormikProps<TFormikValues>;
  /**
   * id is intentionally not optional because checkbox usually should have a label bound
   */
  id: string | undefined;
  name: StringKey<TFormikValues> | NestedFormikName;
}

/*
 FormikCheckboxField component combines legacy styled checkbox with Formik props.
 Note: Use this component only inside Formik forms where legacy checkbox styling is needed.
*/
export const FormikCheckboxField = <TFormikValues,>({
  className,
  disabled,
  formik,
  id,
  name,
}: Props<TFormikValues>): JSX.Element => {
  const field = formik.getFieldProps(name);
  return (
    <input
      type='checkbox'
      className={className}
      id={id}
      name={field.name}
      onChange={field.onChange}
      checked={field.value}
      disabled={disabled}
    />
  );
};
